<section role="region">
  <div class="form-input label">
    <div class="form-checkbox" [attr.checked]="!!value" [attr.disabled]="disabled" (click)="changeValue($event)">
      <label>
        <input
          [id]="elm_id"
          type="checkbox"
          [name]="elm_id"
          class="checkbox"
          [checked]="!!value"
          (keydown.enter)="onKeydownEnter($event)"
        />
        <p class="form-checkbox__label" [innerHTML]="question.title"></p>
      </label>
    </div>
    <app-tooltip *ngIf="question.tooltip as tooltip">
      <p class="form-input__header__container__tooltip" [innerHTML]="tooltip"></p
    ></app-tooltip>
  </div>

  <footer *ngIf="displayActions" class="form-card__actions">
    <button
      class="btn"
      type="button"
      (click)="next(control)"
      [attr.aria-label]="'Valider la question: ' + question.ariaLabel"
    >
      Valider
    </button>
    <button
      *ngIf="!required"
      class="btn-clean"
      type="button"
      (click)="skipQuestion.emit(control)"
      [attr.aria-label]="'Passer la question: ' + question.ariaLabel"
    >
      Passer
    </button>
  </footer>
</section>
